import React from "react";

import RightCaret from "../../../Layout/Icons/RightCaretIcon";

const CollapseButton = ({ toggleTools, toolsVisible }) => {
  const handleClick = () => {
    console.log("CollapseButton clicked - current toolsVisible:", toolsVisible);
    toggleTools();
  };

  return (
    <button
      className={`button button--collapse ${!toolsVisible ? "collapsed" : ""}`}
      onClick={handleClick}
    >
      <RightCaret />
    </button>
  );
};

export default CollapseButton;
